import * as PropTypes from 'prop-types';
import { isBrowser } from "../client";
export function safePropTypesInstanceOf(getExpectedClass) {
  if (isBrowser) {
    return PropTypes.instanceOf(getExpectedClass());
  }

  return PropTypes.any;
}
export function isHTMLElement(el) {
  if (isBrowser) {
    return el instanceof HTMLElement;
  }

  return false;
}
export var globalThat = typeof globalThis === 'object' && globalThis || typeof global === 'object' && global || typeof window === 'object' && window || Function('return this')();